import { render, staticRenderFns } from "./CardDashRoutes.vue?vue&type=template&id=2005bd9c"
import script from "./CardDashRoutes.vue?vue&type=script&lang=js"
export * from "./CardDashRoutes.vue?vue&type=script&lang=js"
import style0 from "./CardDashRoutes.vue?vue&type=style&index=0&id=2005bd9c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2005bd9c')) {
      api.createRecord('2005bd9c', component.options)
    } else {
      api.reload('2005bd9c', component.options)
    }
    module.hot.accept("./CardDashRoutes.vue?vue&type=template&id=2005bd9c", function () {
      api.rerender('2005bd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/RoutesFarmUserManagement/components/CardDashRoutes.vue"
export default component.exports